module.exports = __webpack_public_path__ + "img/Atheer AlHinai.5e2d293b.jpg";